import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { stateType } from "../../types/interface";

interface AppState {
  sendingType: string | null;
  sendingMoneyConfrim: boolean;
  sendingMoneyData: any;
  sendMoneyState: stateType;
  receiverMethod: any;
  receiverAmount: any;
  sendAmount: any;
  receiverExchangeRate: any;
  rateData: any;
  createdRecipientData: {
    countryFlag: string;
    status: string;
    _id: string;
    userId: string;
    firstName: string;
    countryCode: string;
    paymentSource: {
      type: string;
      details: {
        bankName: string;
        accountNumber: string;
        transitNumber: string;
        institutionNumber: string;
        email: string;
      };
    };
    notes: string;
    registrationDate: string;
    lastUpdated: string;
    createdAt: string;
    updatedAt: string;
  };
}

const appActions = createSlice({
  name: "appActions",
  initialState: {
    sendingType: null,
  } as AppState,
  reducers: {
    sendingMoneyOption: (state, action: PayloadAction<string>) => {
      state.sendingType = action.payload;
    },
    sendingMoneyData: (state, action: PayloadAction<any>) => {
      state.sendingMoneyData = action.payload;
    },
    sendingMoneyConfrim: (state, action: PayloadAction<boolean>) => {
      state.sendingMoneyConfrim = action.payload;
    },
    sendMoneyState: (state, action: PayloadAction<stateType>) => {
      state.sendMoneyState = action.payload;
    },
    receiverMethod: (state, action: PayloadAction<any>) => {
      state.receiverMethod = action.payload;
    },
    receiverAmount: (state, action: PayloadAction<any>) => {
      state.receiverAmount = action.payload;
    },
    sendAmount: (state, action: PayloadAction<any>) => {
      state.sendAmount = action.payload;
    },
    rateData: (state, action: PayloadAction<any>) => {
      state.rateData = action.payload;
    },
    receiverExchangeRate: (state, action: PayloadAction<any>) => {
      state.receiverExchangeRate = action.payload;
    },
    createdRecipientData: (state, action: PayloadAction<any>) => {
      state.createdRecipientData = action.payload;
    },
  },
});

export const {
  sendingMoneyOption,
  sendingMoneyData,
  sendingMoneyConfrim,
  sendMoneyState,
  receiverMethod,
  receiverAmount,
  sendAmount,
  rateData,
  createdRecipientData,
} = appActions.actions;
export default appActions.reducer;
